import BreadcrumbPanel from "../breadcrumb/BreadcrumbPanel";
import OverviewTabs from "./OverviewTabs";

const OverviewComponent = ({
  breadcrumbItems,
  options,
  defaultTabValue = "all",
  tabs,
}) => {
  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0 md:gap-8">
        <OverviewTabs
          options={options}
          tabs={tabs}
          defaultTabValue={defaultTabValue}
        />
      </div>
    </>
  );
};

export default OverviewComponent;
